import { Grid } from "@mui/material";
import React, { FC } from "react";

interface Props {}

export const ScreenshotRowLabel: FC<Props> = () => {
  const flexCenterStyle = { display: "flex", justifyContent: "center" };

  return (
    <Grid
      container
      style={{ borderBottom: "1px solid #AEB4BE", padding: "1em 0" }}
    >
      <Grid item xs={2} style={flexCenterStyle}>
        Component
      </Grid>
      <Grid item xs={3} style={flexCenterStyle}>
        Product
      </Grid>
      <Grid item xs={5} style={flexCenterStyle}>
        Details
      </Grid>
      <Grid item xs={2} style={flexCenterStyle}>
        Price
      </Grid>
    </Grid>
  );
};
